module.exports = __webpack_public_path__ + "media/swirls_of_stream.5040f59e.mp3";